'use client';

import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { Plus, X } from 'lucide-react';
import React from 'react';
import { cn } from '@/lib/utils';

import { faqData } from './faqData';

export const Faq = () => {
  const [activeValue, setActiveValue] = React.useState('item-0');

  return (
    <div className='mt-[40px] w-full px-[15px] lg_mt-[80px] lg_px-0'>
      <h2 className='mb-[20px] font-teko-medium text-[30px] font-medium uppercase leading-[40px] lg_mb-[30px] lg_text-[40px]'>
        FAQ
      </h2>
      <AccordionPrimitive.Root
        type='single'
        collapsible
        className='w-full border-t border-[#E5E5E5]'
        value={activeValue}
        onValueChange={setActiveValue}
      >
        {faqData.map((item, index) => {
          const isOpen = activeValue === `item-${index}`;
          return (
            <AccordionPrimitive.Item
              key={index}
              value={`item-${index}`}
              className='border-b border-[#E5E5E5]'
            >
              <AccordionPrimitive.Header className='flex'>
                <AccordionPrimitive.Trigger
                  className='flex flex-1 items-center justify-between gap-[16px] py-[20px] text-left font-roboto-medium text-[16px] leading-[24px] lg_py-[24px] lg_text-[18px]'
                >
                  <span className='flex-1'>{item.question}</span>
                  {isOpen ? (
                    <X className='h-[20px] w-[20px] shrink-0 text-[#000] lg_h-[24px] lg_w-[24px]' />
                  ) : (
                    <Plus className='h-[20px] w-[20px] shrink-0 text-[#000] lg_h-[24px] lg_w-[24px]' />
                  )}
                </AccordionPrimitive.Trigger>
              </AccordionPrimitive.Header>
            <AccordionPrimitive.Content className='data-[state=closed]_animate-accordion-up data-[state=open]_animate-accordion-down overflow-hidden font-roboto-regular text-[14px] leading-[22px] text-[#666] lg_text-[16px] lg_leading-[26px]'>
              <div className='pb-[20px] lg_pb-[24px]'>
                {item.answer}
              </div>
            </AccordionPrimitive.Content>
          </AccordionPrimitive.Item>
          );
        })}
      </AccordionPrimitive.Root>
    </div>
  );
};
